
import {tap} from 'rxjs/operators';
import {Injectable} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";

/** Logs any API errors to debug console, without intercepting them
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor() {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap(() => {
                // do nothing
            }, (err: any) => {
                if (err instanceof HttpErrorResponse)
                    console.error(`API HTTP error: ${err.status} - ${err.name} : ${err.message}`, err.error);
                else
                    console.error(`API error: ${err}}`, err);
            }));
    }
}
